export default __webpack_public_path__ + "f65497662eeaf718d2b5b781a807ccd9.png";